/* eslint-disable no-debugger */
import * as Yup from 'yup';

export const genericFormSchema = Yup.object().shape({
  firstName: Yup.string(),
  familyName: Yup.string(),
  birthYear: Yup.number()
    .min(new Date().getFullYear() - 100, 'birthYear.min')
    .max(new Date().getFullYear(), 'birthYear.max'),
  city: Yup.string(),
  postcode: Yup.string(),
  bestApprentice: Yup.object().optional(),
  bestWorker: Yup.object().optional(),
  natFinalsYear: Yup.number()
    .min(new Date().getFullYear() - 100, 'natFinalsYear.min')
    .max(new Date().getFullYear(), 'natFinalsYear.max'),
  natFinalsRank: Yup.object().optional(),
  euroSkillsYear: Yup.number('euroSkillsYear.number')
    .min(new Date().getFullYear() - 100, 'euroSkillsYear.min')
    .max(new Date().getFullYear(), 'euroSkillsYear.max')
    .optional(),
  natFinalsRegion: Yup.object().optional(),
  trainingAndDiploma1: Yup.string(),
  trainingAndDiploma2: Yup.string().optional(),
  trainingAndDiploma3: Yup.string(),
  worldSkillsProfession: Yup.object().optional(),
  worldSkillsYear: Yup.number()
    .min(new Date().getFullYear() - 100, 'worldSkillsYear.min')
    .max(new Date().getFullYear(), 'worldSkillsYear.max')
    .optional(),
  currentCompanyCityDept: Yup.string().optional(),
  currentJobName: Yup.string().optional(''),
  gender: Yup.object(),
  facebookAddress: Yup.string().optional().url('facebookAddress.url'),
  instagramAddress: Yup.string().optional().url('instagramAddress.url'),
  tiktokAddress: Yup.string().optional().url('tiktokAddress.url'),
  region: Yup.object().typeError('region'),
  mobileNumber: Yup.string().matches(/^\+?\d(?:[\d\s]*)$/, 'mobileNumber.correctFormat'),
  montherLanguage: Yup.object(),
  otherLanguage: Yup.string().optional(),
  specialJobTitle: Yup.object().typeError('specialJobTitle'),
  profession: Yup.object(),
  swissChampionYear: Yup.number()
    .min(new Date().getFullYear() - 100, 'swissChampionYear.min')
    .max(new Date().getFullYear(), 'swissChampionYear.max')
    .optional(),
  swissChampionRank: Yup.object().optional(),
  associationProfession: Yup.object().typeError('associationProfession'),
  vocationSchool: Yup.object().typeError('vocationSchool'),
  functions: Yup.array(),

  recentProfession1: Yup.string(),
  recentProfession2: Yup.string().nullable(),
  recentProfession3: Yup.string().nullable(),
  linkedinAddress: Yup.string().optional().url('linkedinAddress.url'),
  participationType: Yup.object().optional().nullable(),
  abilympicsProfession: Yup.object().optional(),
  consent: Yup.boolean().isTrue('consent').nullable(),
  regionalEvents: Yup.array().optional(),
  participantLocation: Yup.object().optional(),
  freeText: Yup.string().optional(),
  freeText2: Yup.string().optional(),
  companyInformation: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required('companyInformation.name.required'),
        city: Yup.string().required('companyInformation.city.required'),
        department: Yup.string().required('companyInformation.department.required'),
        current: Yup.boolean().default(false)
      })
    )
    .optional(),
  educationInformation: Yup.array()
    .of(
      Yup.object().shape({
        typeOfEstablishment: Yup.string().required(
          'educationInformation.typeOfEstablishment.required'
        ),
        nameOfEstablishment: Yup.string().required(
          'educationInformation.nameOfEstablishment.required'
        ),
        cityOfEstablishment: Yup.string().required(
          'educationInformation.cityOfEstablishment.required'
        ),
        departmentOfEstablishment: Yup.string().required(
          'educationInformation.departmentOfEstablishment.required'
        ),
        diplomaTitle: Yup.string().required('educationInformation.diplomaTitle.required'),
        diplomaCompleted: Yup.boolean().default(false),
        yearOfCompletion: Yup.number().nullable().optional(),
        current: Yup.boolean()
      })
    )
    .optional()
});

export const LoginSchema = Yup.object({
  email: Yup.string().email('email.correctEmail').required('email.required'),
  lang: Yup.object()
});

export const videoHelpSchema = Yup.object({
  tel: Yup.string().min(9).max(15).required('Veuillez saisir votre prénom!')
});
